import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import get from 'lodash/get';
import TablePanel from './TablePanel';
import ReactSparkModal from '../../../helpers/CTModal';
import { withRouter } from 'react-router';
import { checkPermissionForLevel } from '../../../../../lib/utils';
import { SparkTabs } from '../../../ui/spark';
import { THEME_CATEGORY } from '../../../../constants/ThemeCategories';

class TablePanelView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
            source: null,
            activeTab: 'hosted'
        };
        this.onCopy = this.onCopy.bind(this);
    }

    componentDidMount() {
        // Only initialize SparkTabs when inContextBeta is true and tabs are rendered
        if (this.props.inContextBeta && this.tabsNode) {
            this.tabsElm = new SparkTabs(this.tabsNode);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.inContextBeta !== this.props.inContextBeta) {
            if (this.props.inContextBeta && this.tabsNode && !this.tabsElm) {
                this.tabsElm = new SparkTabs(this.tabsNode);
            } else if (!this.props.inContextBeta && this.tabsElm) {
                if (this.tabsElm.destroy) {
                    this.tabsElm.destroy();
                }
                this.tabsElm = null;
            }
        }
        
        // Reinitialize tabs if the node exists but SparkTabs wasn't initialized
        if (this.props.inContextBeta && this.tabsNode && !this.tabsElm) {
            this.tabsElm = new SparkTabs(this.tabsNode);
        }
    }

    componentWillUnmount() {
        if (this.tabsElm && this.tabsElm.destroy) {
            this.tabsElm.destroy();
        }
    }

    onCopy(sourceItem, event) {
        this.setState({
            source: sourceItem,
            openModal: !this.state.openModal
        });
    }

    handleTabClick(tabName) {
        this.setState({ activeTab: tabName });
    }

    _renderSparkPanelContent(isUploadFileAllowed, currentContent, category) {
        return (
            <div className="spark-panel__content">
                {this.props.inContextBeta && <h3>{this.props.headline}</h3>}
                {isUploadFileAllowed && (
                    <button
                        onClick={() => {
                            this.props.onBeforeUpload && this.props.onBeforeUpload(category);
                            this.props.router.push(`/manage/${this.props.uploadUrl}?category=${category}`);
                        }}
                        className="spark-btn spark-btn--sm upload-file-btn"
                    >
                        Upload {this.props.itemName} file
                    </button>
                )}
                <TablePanel
                    id={this.props.id + '-panel'}
                    defaultContent={this.props.defaultContent}
                    content={currentContent}
                    category={category}
                    chain={this.props.chain}
                    hotel={this.props.hotel}
                    onDeleteClick={this.props.onDeleteClick}
                    onCopy={this.onCopy}
                    onShowInfo={this.props.onShowInfo}
                    setData={this.props.setData}
                    contenttype={this.props.contenttype}
                    uploadUrl={this.props.uploadUrl}
                    itemName={this.props.itemName}
                />
                <ReactSparkModal
                    open={this.state.openModal}
                    primaryButtonTitle="Copy"
                    primaryButton={true}
                    secondaryButton={true}
                    contenttype={this.props.contenttype}
                    primaryButtonClick={() => {
                        if (this.props.name && this.props.code) {
                            this.props.onSubmit(this.state.source);
                            this.setState({ openModal: false });
                        } else {
                            this.props.showValidation();
                        }
                    }}
                    onClose={() => {
                        this.props.clearComments();
                        this.setState({ openModal: false });
                        this.props.clearCode();
                    }}
                    secondaryButtonClick={() => {
                        this.props.clearComments();
                        this.setState({ openModal: false });
                        this.props.clearCode();
                    }}
                    secondaryButtonTitle="Cancel"
                >
                    {this.props.children}
                </ReactSparkModal>
            </div>
        );
    }

    _renderInContextTabs(isUploadFileAllowed) {
        return (
            <div ref={node => (this.tabsNode = node)} className="spark-tabs">
                <nav className="spark-tabs__nav" role="menubar">
                    <div className="spark-tabs__scroll">
                        <ul className="spark-tabs__list" role="tablist">
                            <li
                                className="spark-tabs__tab active text-center"
                                role="tab"
                                aria-controls="hosted-tab"
                                onClick={() => this.handleTabClick('hosted')}
                            >
                                <a>Hosted</a>
                            </li>
                            <li
                                className="spark-tabs__tab  text-center"
                                role="tab"
                                aria-controls="incontext-tab"
                                onClick={() => this.handleTabClick('incontext')}
                            >
                                <a>In-context</a>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div className="spark-tabs__panels">
                    <div role="tabpanel" className="spark-tabs__panel" id="hosted-tab">
                        {this._renderSparkPanelContent(isUploadFileAllowed, this.props.hostedContent, THEME_CATEGORY.SBE)}
                    </div>
                    <div role="tabpanel" className="spark-tabs__panel" id="incontext-tab">
                        {this._renderSparkPanelContent(isUploadFileAllowed, this.props.inContextContent, THEME_CATEGORY.SBEM)}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { accessLevel, userPermissionLevels, selectedLevel, contenttype } = this.props;
        const isUploadFileAllowed = checkPermissionForLevel(
            accessLevel,
            contenttype,
            'ADD',
            userPermissionLevels,
            selectedLevel
        );

        return (
            <div 
                className={classnames('spark-panel spark-mar-t-1',
                    { 'panel-bg-gray':  this.props.inContextBeta})}
            >
                {
                    this.props.inContextBeta?
                    (<div>
                        <h3 className="spark-margin-bottom--lg">{this.props.headline}</h3>
                        {this._renderInContextTabs(isUploadFileAllowed)}
                    </div>)
                    : this._renderSparkPanelContent(isUploadFileAllowed, this.props.hostedContent, THEME_CATEGORY.SBE)
                }
            </div>
        );
    }
}

TablePanelView.propTypes = {
    content: PropTypes.array,
    hostedContent: PropTypes.array,
    inContextBeta: PropTypes.bool,
    inContextContent: PropTypes.array,
    onSubmit: PropTypes.func,
    onBeforeUpload: PropTypes.func,
    contentLevel: PropTypes.object,
    onDispatch: PropTypes.func,
    headline: PropTypes.string,
    buttonComment: PropTypes.string,
    id: PropTypes.string,
    children: PropTypes.element,
    onShowInfo: PropTypes.func,
    showValidation: PropTypes.func,
    uploadUrl: PropTypes.string,
    itemName: PropTypes.string
};

const mapStateToProps = state => {
    return {
        accessLevel: state.oauth.accessLevel,
        userPermissionLevels: state.oauth.userPermissionLevels,
        selectedLevel: state.app.selected.level
    };
};

export default connect(mapStateToProps)(withRouter(TablePanelView));



// WEBPACK FOOTER //
// ./src/components/pages/manage/common/TablePanelView.js